<top-banner variant="title" [title]="selectedSite?.name"></top-banner>

<div class="main-content">
  <div class="row">
    <div class="col-md-12">
      <div class="card">
        <div class="row">
          <div class="col-md-2 cardtabs-wrapper">
            <app-site-tab-menu [site]="selectedSite"></app-site-tab-menu>
          </div>
          <div class="col-md-10">
            <card-section-header
              title="Details"
              icon="fas fa-pen-to-square">
            </card-section-header>

            <div class="mb-2 animated fadeIn">
              <form [formGroup]="siteDetailsForm" (ngSubmit)="onSiteDetailsFormSubmit()">
                <div class="form-row">
                  <div class="col-md-5" style="margin-top: 27px;">
                    <div class="form-group">
                      <label>Name</label>
                      <input type="text" class="form-control" formControlName="name">
                    </div>
                    <div class="form-group" *ngIf="siteOwners.length">
                      <label>Owner</label>
                      <p-dropdown class="form-control" [(ngModel)]="selectedOwner"
                        (ngModelChange)="onSelectedSiteOwnerChange($event)"
                        [ngModelOptions]="{standalone: true}" [options]="siteOwners"
                        optionLabel="label" [style]="{'width':'100%'}" filter="true">
                      </p-dropdown>
                    </div>
                  </div>

                  <!-- Separator Column -->
                  <div class="col-md-1 d-flex justify-content-center">
                    <div style="border-left: 1px solid #DDDDDD; height: 100%;"></div>
                  </div>

                  <div class="col-md-4">
                    <h6 class="card-title">Contact Numbers</h6>
                    <div class="form-group">
                      <label>Main Contact Number</label>
                      <input type="text" class="form-control" formControlName="mainContactNumber" placeholder="">
                    </div>
                    <div class="form-group">
                      <label>Emergency Contact Number</label>
                      <input type="text" class="form-control" formControlName="emergencyContactNumber" placeholder="">
                    </div>
                    <div class="form-group">
                      <label>Regional Emergency Contact Number</label>
                      <input type="text" class="form-control" formControlName="altEmergencyContactNumber" placeholder="">
                    </div>
                  </div>
                </div>

                <div class="form-row">
                  <div class="col-md-10">
                    <div class="form-group">
                      <label>Description</label>
                      <textarea type="text" class="form-control" formControlName="description"></textarea>
                    </div>
                  </div>
                </div>

                <div class="form-row">
                  <div class="col-md-4">
                    <div class="form-group">
                      <label>Waypoint Interval (minutes)</label>
                      <input type="number" class="form-control" formControlName="waypointInterval">
                    </div>
                  </div>
                </div>

                <div class="form-row">
                  <div class="col-md-4" *ngIf="availableInductions.length">
                    <div class="form-group">
                      <label>Site Induction </label>
                      <p-dropdown
                          class="pDropdownCustom"
                          [ngModel]="selectedInduction"
                          (ngModelChange)="onSelectedSiteInductionChange($event)"
                          [ngModelOptions]="{standalone: true}"
                          [options]="availableInductions"
                          optionLabel="label"
                          placeholder="Choose An Induction"
                          filter="true">
                      </p-dropdown>

                      <button type="button" (click)="removeInduction()" class="btn btn-danger btn-link" *ngIf="!!selectedInduction">
                        remove induction
                      </button>
                    </div>
                  </div>
                </div>
                <!-- never used anymore
                <div class="form-row">
                  <div class="col-md-4">
                    <div class="form-group form-group-checkbox mt-0">
                      <label>Assets can have Competencies?</label>
                      <p-checkbox class="form-control" formControlName="addAssetCompetencies" binary="true"></p-checkbox>
                    </div>
                  </div>
                </div>
                -->
                <br>
                <div class="form-row">
                  <div class="col-md-10 mt-4 mb-4">
                    <button type="submit" class="btn btn-success btn-round">
                      Save
                    </button>
                    <button type="button" class="btn btn-default btn-round float-right" (click)="deleteSite()">Delete Site</button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
